import { createI18n } from 'vue-i18n';

const i18n = createI18n({
  legacy: false,
  locale: 'es_ar',
  fallbackLocale: 'es_ar',
  messages: {}, // cargamos dinámicamente después
});

export default i18n;

export const getOptionsLanguages = () => {
  const files = import.meta.glob('/src/lang/*.json', { eager: true });

  const languages = Object.keys(files).map((path) => {
    const fileName = path.split('/').pop();
    if(!fileName) return null;
    return {
      id: fileName.replace('.json', ''),
      nombre: fileName.replace('.json', ''),
      file: fileName,
      content: files[path],
    };
  });
  return languages;
};
